import React from "react";
import { useWorkspaceColors } from "../../Contexts/WorkspaceColorContext";
import { useUser } from "../../Query/useUsers";
import Loading from "../Common/Loading";
import HomeComponent from "./Home";
import color from "../../Constants/colors";

const EvaluationHome: React.FC = () => {
  const { data: userData, isLoading } = useUser();
  const { colors: workspace } = useWorkspaceColors();

  if (isLoading) {
    return (
      <Loading
        backgroundColor={color.gray100}
        color1={workspace.accent}
        color2={workspace.primary_dark}
      />
    );
  }

  return (
    <div>
      <HomeComponent user={userData} />
    </div>
  );
};

export default EvaluationHome;
